<template src="./template.html"></template>

<script>
import _ from 'lodash'
import InvoiceType from './InvoiceType.vue'
import MyAlert from '../../components/alert/MyAlert.vue'
import MyPersons from '../../components/MyPersons.vue'
import MyAbouts from '../../components/MyAbouts.vue'
import MyMobile from '../../components/MyMobile.vue'
import MyTextareaComment from '../../components/MyTextareaComment.vue'
import MyNumber from '../../components/MyNumber.vue'
import MyBalances from '../../components/MyBalances.vue'
import MyButtons from '../add/Buttons.vue'
import MyInvoiceTable from './table.vue'
import MyRpTable from '../rp/table.vue'
import PrintInvoiceLabel from '../../components/alert/printInvoiceLabel.vue'
import Utils from '../../functions/utils'

export default {
  name: 'InvoiceItems',
  props: ['formTitle'],
  components: {
    InvoiceType,
    MyAlert,
    MyButtons,
    MyPersons,
    MyAbouts,
    MyMobile,
    MyTextareaComment,
    MyNumber,
    MyBalances,
    MyInvoiceTable,
    MyRpTable,
    PrintInvoiceLabel,
  },
  data() {
    return {
      submitStatus: null,
      validation: false,
      showAlert: false,
      returnSaveData: Object,
      //
      prevInvoiceType: null,
      prevPerson_id: null,
      prevBalance: 0,
      invoice_id: null,
      invoice: {
        type: null,
        mobile: null,
        items: []
      },
      balance: {
        current: 0,
        new: 0
      },
      lendingBalance: 0,
      //
      isDirty: false,
      originalInvoice: null,
      stabilizeTimer: null,
      //print label
      // showWeightTable: false
    }
  },
  computed: {
    // clonedInvoice() {
    //   return JSON.parse(JSON.stringify(this.invoice))
    // },
    invoiceTotal() {
      return this.invoice.items.reduce((acc, item) => {
        if (item.value && item.price && item.product?.n) {
          const Total = (item.value * item.price) * item.product.n
          return acc + Math.round(Total / 10) * 10
        }
        return acc
      }, 0)
    },
    invoicePrice() {
      const discountItem = this.invoice.items.find(x => x.discount)
      if (!discountItem?.discount) return 0
      const discount = Number(Utils.rmCamma(discountItem.price))
      const invoiceTotal = this.invoiceTotal
      const isCostId = discountItem.discount.label === 'cost_id'
      const isBuys = this.invoice.type === 'buy'
      const sign = (isBuys === isCostId) ? 1 : -1
      return invoiceTotal + sign * discount
    },
  },
  watch: {
    invoice: {
      deep: true,
      handler(newVal) {
        if (!this.originalInvoice) {
          clearTimeout(this.stabilizeTimer)
          this.stabilizeTimer = setTimeout(() => {
            this.originalInvoice = _.cloneDeep(this.invoice)
            this.isDirty = false
          }, 300)
        } else this.isDirty = !_.isEqual(newVal, this.originalInvoice)
      }
    },
    'invoice.person_id'(newVal) {
      if (!newVal) this.balance = {
        current: 0,
        new: 0
      }
    },
    invoicePrice(newVal) {
      this.calcNewBalance(newVal)
    },
  },
  async beforeCreate() {
    this.formState = this.$router.currentRoute.path.split("/")[2]
    this.route = this.$store.getters.pageInfo.route
    if (this.formState === 'edit') {
      const mid = this.$router.currentRoute.path.split("/")[3]
      await this.$store.dispatch('getInfo', {
        url: `/api/${this.route}`,
        params: {
          mid
        }
      })
      this.invoice = this.$store.getters.editData
      this.prevPerson_id = this.invoice.person_id
      this.prevInvoiceType = this.invoice.type
      this.prevBalance = this.invoicePrice
      await this.setBalance()
    }
  },
  created() {
    if (this.formState !== 'edit') {
      this.invoice.type = 'sale'
      this.addInvoiceRow(this.invoice)
      this.invoice.items.push({
        discount: 1,
        price: 0
      })
    }
  },
  mounted() {
    // if (this.$refs.vradio) this.$refs.vradio.$el.children[0].children[1].focus()
    this.$refs.vradio?.$el?.children[0]?.children[1]?.focus()
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  beforeDestroy() {
    clearTimeout(this.stabilizeTimer)
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
  methods: {
    handleBeforeUnload(event) {
      if (this.isDirty) {
        event.preventDefault();
        event.returnValue = ''
      }
    },
    async onSave(e) {
      this.$refs.form.validate()
      if (!this.validation || this.submitStatus === 'PENDING') return
      if (!this.invoice.type && this.route) this.invoice.type = this.route.slice(0, -1)
      const method = this.formState === 'edit' ? 'PUT' : 'POST'
      const payload = {
        method,
        url: `/api/${this.route}`,
        data: {
          data: this.invoice
        }
      }
      if (!e?.esc && !window.confirm('آیا مایل به ذخیره فاکتور هستید؟')) return
      try {
        this.submitStatus = 'PENDING'
        await this.$store.dispatch('save', payload)
        const res = this.$store.getters.saveData
        if (res?.insert || res?.update) {
          if (res._id) this.invoice_id = res._id
          if (res.data) this.returnSaveData = res.data
          this.showAlert = true
          this.originalInvoice = _.cloneDeep(this.invoice)
          this.isDirty = false
        } else this.submitStatus = null
      } catch (err) {
        console.error(err);
        this.submitStatus = null
      }
    },
    async setBalance() {
      if (!this.invoice.person_id) return
      try {
        const res = await this.personBalance(this.invoice.person_id, 'balance')
        this.balance.current = res.balance
        const resLending = await this.personBalance(this.invoice.person_id, 'lendingBalance')
        this.lendingBalance = resLending.balance
        this.calcNewBalance(this.invoicePrice)
      } catch (err) {
        console.error(err)
      }
    },
    async calcNewBalance(invoicePrice) {
      let newBalance = this.balance.current
      const isAdd = this.formState === 'add'
      const samePerson = this.invoice.person_id === this.prevPerson_id
      if (this.invoice.type === 'buy') {
        if (isAdd) newBalance -= invoicePrice
        else if (samePerson) newBalance = this.prevInvoiceType === 'buy' ? this.balance.current + this.prevBalance - invoicePrice : this.balance.current - this.prevBalance - invoicePrice
        else newBalance -= invoicePrice
      } else if (this.invoice.type === 'sale') {
        if (isAdd) newBalance += invoicePrice
        else if (samePerson) newBalance = this.prevInvoiceType === 'sale' ? this.balance.current - this.prevBalance + invoicePrice : this.balance.current + this.prevBalance + invoicePrice
        else newBalance += invoicePrice
      }
      this.balance.new = newBalance
    },
    changeInvoiceType() {
      this.calcNewBalance(this.invoicePrice)
    },
    addInvoiceRow(item) {
      const i = [...this.invoice.items]
      const newItem = {
        product: null,
        n: null,
        lending: false,
        value: null,
        price: null
      }
      i.splice(i.indexOf(item) + 1, 0, newItem)
      this.invoice.items = i
    },
    removeInvoiceRow(item) {
      const i = [...this.invoice.items]
      i.splice(i.indexOf(item), 1)
      this.invoice.items = i
    },
    getLocalStorage(item, index) {
      if (!item.product._id || item.price) return
      let defaultPrice = JSON.parse(localStorage.getItem(`${this.invoice.type}${item.product._id}`) || '{}')
      if (defaultPrice[item.product._id]?.[this.invoice.type]) this.invoice.items[index].price = defaultPrice[item.product._id][this.invoice.type].price
    },
    setLocalStorage(item) {
      if (!item.product._id || !item.price || item.price === '0') return
      const product_id = String(item.product._id)
      const defaultPrices = {
        [product_id]: {
          [this.invoice.type]: {
            price: this.rmCamma(item.price)
          }
        }
      }
      localStorage.setItem(`${this.invoice.type}${product_id}`, JSON.stringify(defaultPrices))
    },
    onSelectAbout(item) {
      if (!item || !item.mobile) return
      if (!this.invoice.mobile) {
        this.invoice.mobile = item.mobile || ''
      }
    }
  },
}
</script>
